<template>
    <v-select :value="value"
              @input="$emit('input', $event)"
              multiple
              @search="fetchOrganizations"
              :options="options"
              push-tags
              :filterable="false">
        <template slot="no-options">
            type to search customers...
        </template>
        <template slot="option" slot-scope="org">
            {{ org.name }}
        </template>
        <template slot="selected-option" slot-scope="org">
            {{ org.name }}
        </template>
    </v-select>
</template>

<script>

import vSelect from "vue-select"
import normalize from "json-api-normalize";
import Attributes from "../../../models/Attributes";

export default {
  props: ['value', 'initialOptions'],

  data() {
    return {
      options: this.initialOptions || []
    }
  },

  methods: {
    fetchOrganizations(search, loading) {
      loading(true)
      this.search(loading, search, this)
    },

    search: _.debounce((loading, search, vm) => {
      const url = `/curators/organizations?query=${escape(search)}`
      vm.$http.get(url).then(fulfilled => {
        vm.options = normalize(fulfilled.data).get(Attributes.organizationAttributes)
        loading(false)
      })
    }, 350)
  },

  components: {vSelect}
}
</script>